// extracted by mini-css-extract-plugin
export default {"richTextContainer":"richTextEditor_richTextContainer__Q5GjD","errorText":"richTextEditor_errorText__iKeQW"};